export const PRIVACY_CONTROLLER = "Alabastra";
export const PRIVACY_CONTACT_EMAIL = "contato@alabastra.org";
export const PRIVACY_INSTAGRAM = "@alabastra.perfume";
export const COURSE_NAME = "Entender de perfume";
